import { convertToNative } from "./convertToNative";
export const unmarshall = (data, options) => convertToNative({ M: data }, options);
